import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import BibleReader from "./pages/BibleReader";
import Tracts from "./pages/Tracts";
import Resources from "./pages/Resources";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Articles from "./pages/Articles";
import ArticleDetail from "./pages/ArticleDetail";
import { ReadingPlansList, ReadingPlanDetail } from "./pages/ReadingPlans";
import Bookmarks from "./pages/Bookmarks";
import PaymentReturn from "./pages/PaymentReturn";
import Videos from "./pages/Videos";
import "./App.css";

function RequireAdmin({ children }) {
  const { admin, ready } = useAuth();
  if (!ready) return <div className="p-8 text-stone-500">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/bible" element={<Layout hideSidebar><BibleReader /></Layout>} />
            <Route path="/tracts" element={<Layout><Tracts /></Layout>} />
            <Route path="/resources" element={<Layout hideSidebar><Resources /></Layout>} />
            <Route path="/articles" element={<Layout><Articles /></Layout>} />
            <Route path="/articles/:slug" element={<Layout hideSidebar><ArticleDetail /></Layout>} />
            <Route path="/plans" element={<Layout><ReadingPlansList /></Layout>} />
            <Route path="/plans/:id" element={<Layout hideSidebar><ReadingPlanDetail /></Layout>} />
            <Route path="/bookmarks" element={<Layout hideSidebar><Bookmarks /></Layout>} />
            <Route path="/payment/return" element={<Layout hideSidebar><PaymentReturn /></Layout>} />
            <Route path="/videos" element={<Layout><Videos /></Layout>} />
            <Route path="/admin/login" element={<Layout hideSidebar><AdminLogin /></Layout>} />
            <Route path="/admin" element={<RequireAdmin><Layout><AdminDashboard /></Layout></RequireAdmin>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
